<template>
  <div>
    <filter-bar
      v-if="isFilterOpen"
      :configuration="filterConfigMapping"
      :facets="disputeRecordsFacets"
      :filter-data="filterDataByName"
      :show-apply-button="false"
      :default-columns="defaultFilterColumns"
      :cache-name="filterCacheName"
      :saved-filters="savedFilterPreferences"
      :current-filter="currentFilter"
      :is-saved-filters-loading="isSavedFiltersLoading"
      :show-share-button="!isFiltersEmpty"
      @onClose="onFilterToggle"
      @onCardToggle="onFilterCardToggle"
      @onCheckboxSelect="onFilterCheckboxSelect"
      @onCheckboxMultiSelect="onCheckboxMultiSelect"
      @onDateSelect="onDateSelect"
      @onSaveColumnConfig="onSaveColumnConfig"
      @onApplySavedFilter="onApplySavedFilter"
      @onSaveNewFilter="onSaveNewFilter"
      @onFilterClear="onFilterClear"
      @onSavedFilterModalOpen="fetchFilterPreference"
      @onShareFilterModal="onShareFilterModal"
      @onCloseShareFilterModal="onCloseShareFilterModal"
      @onSearchUpdateFacetIfNotFound="onSearchUpdateFacetIfNotFound"
      @onClearFacet="onClearFacet"
      @onSavedFilterDelete="onSavedFilterDelete" />
    <div class="main-content" :class="tableClassName">
      <div class="dashboard">
        <!-- <notification
            type="error"
            icon="exclamation-triangle"
            title="Warning !"
            class="dashboard__warning"
          >
            <p> Our System is getting upgraded, please note for S/4 Sealand Pilot countries “Belgium, Denmark, France, Germany, the Netherlands, Sweden, and the United Kingdom” Dispute View and GAM will be down from MAY 26th 18:00 CET- JUNE 2nd. Within this period all dispute related activities will be on hold and you might experience delay in dispute related services.</p>
          </notification> -->
        <div class="content-area">
          <div class="title-area">
            <div class="rich-text">
              <h3 class="title">
                OHP Disputes -
                <span class="title--color">Agent Dashboard</span>
              </h3>
            </div>
            <div
              v-tooltip="
                assignedDisputeList?.length >= 10
                  ? `You already have ${assignedDisputeList?.length} cases assigned`
                  : ''
              "
              class="case-assign-area">
              <form-select
                id="assign-cases"
                :options="numberOfCasesOptions"
                :value="selectedCasesCount"
                :disabled="assignedDisputeList?.length >= 10"
                placeholder="Select Number of cases"
                class="case-assign-area__cases"
                @input="selectChangeHandler($event)" />
              <Button
                :disabled="selectedCasesCount?.value == ''"
                label="Assign Cases"
                appearance="secondary"
                icon="user-circle"
                icon-position="left"
                class="button-pull-cases"
                @onClick="assignCases" />
            </div>
          </div>
          <div class="search-area" :class="searchActiveClass">
            <div class="left-content">
              <div class="button-group">
                <span class="filter-toggle-button-container">
                  <Button
                    label="Filter"
                    icon="bars-horizontal-funnel-down"
                    icon-position="left"
                    class="button-group__button"
                    @onClick="onFilterToggle" />
                  <span
                    v-if="!isFiltersEmpty"
                    class="filter-change-circle"></span>
                </span>
                <Button
                  :label="switchViewText"
                  appearance="tertiary"
                  icon="book-open"
                  icon-position="left"
                  class="button-group__button"
                  @onClick="handleViewChange" />
                <Button
                  appearance="tertiary"
                  icon="magnifying-glass"
                  icon-position="left"
                  icon-only
                  class="button-group__button search-button" />
              </div>
              <div class="search-box">
                <text-input
                  id="dispute-search-input"
                  :show-clear-button="true"
                  :value="searchTerm"
                  placeholder="Search for dispute (minimum 3 characters)"
                  icon="magnifying-glass"
                  icon-position="left"
                  :error="disputeSearchInputError"
                  :error-message="
                    disputeSearchInputError
                      ? 'Search supports maximum 500 characters'
                      : ''
                  "
                  @onChange="onSearch"
                  @onClear="onClear" />
                <a class="search-cancel-button">Cancel</a>
              </div>
            </div>
            <div class="right-content">
              <div v-if="selectedSort" class="sort-area">
                <form-select
                  id="dispute-sort"
                  v-tooltip="`${selectedSortWithoutTruncate}`"
                  :vanity-style="true"
                  :options="getSortOptions"
                  optional-label
                  label="Sort By:"
                  :value="selectedSortOption"
                  @input="onSortChange($event)" />
              </div>
              <Button
                v-tooltip="`Export data as excel sheet (.xlsx)`"
                appearance="tertiary"
                icon="tray-arrow-down"
                icon-position="left"
                icon-only
                class="button-group__button download-button"
                @onClick="onExportExcelModalOpen" />
            </div>
          </div>
          <div class="configure-area">
            <div
              v-if="!disputeRecordsLoading"
              class="configure-area-page-items">
              Showing
              <strong v-if="disputeRecordsCount <= pagination.itemsPerPage">{{
                disputeRecordsCountFormatted
              }}</strong>
              <strong v-else>
                {{ `${paginationStartCount} - ${disputeRecordsCount &lt; paginationEndCount ? disputeRecordsCount : paginationEndCount}` }}
                of {{ disputeRecordsCountFormatted }}
              </strong>
              items
            </div>

            <Button
              v-if="cardType === 'list'"
              label="Configure Columns"
              appearance="tertiary"
              icon="sliders-horizontal"
              icon-position="left"
              class="button-group__button"
              @onClick="handleListViewConfigureModal" />
          </div>
          <filter-tags
            v-if="!isFiltersEmpty"
            :content="filterDataByName"
            :is-filter-open="isFilterOpen"
            @onRemoveFilter="onRemoveFilter($event)"
            @onClearFilter="onFilterClear" />
          <div class="tab-area">
            <div
              v-if="cardType === 'list' && selectedRowsPerPage.length"
              class="tab-area__bulk-menu">
              <div class="tab-area__bulk-menu__label">
                {{
                  selectedRowsPerPage.length
                    ? `${selectedRowsPerPage.length} ${
                        selectedRowsPerPage.length > 1 ? "Items" : "Item"
                      } Selected`
                    : ""
                }}
              </div>
              <form-select
                id="bulk-select"
                label=""
                :value="bulkUpdateValue"
                help-message
                error-message
                optional-label
                :options="getSelectOptions"
                :disabled="bulkEditDisabled"
                placeholder="Select Action"
                @input="handleMultiActionSelect($event)" />
            </div>
            <h4 v-if="disputeRecordsError" class="error-message">
              Unable to fetch data, please try again by refreshing the page, if
              issue still persist kindly try any of the following method
              <ul>
                <li>Clear your browser cache</li>
                <li>Try in private window(Incognito)</li>
              </ul>
            </h4>
            <h4 v-else-if="disputeRecordsLoading" class="error-message">
              <dashboard-skeleton :count="3" />
            </h4>
          </div>
        </div>
        <div
          v-if="disputeRecords.length && !disputeRecordsLoading"
          class="menu-container">
          <div slot="content">
            <loading
              :active.sync="resolutionModalLoading"
              :can-cancel="false"
              :is-full-page="true"
              color="#0573ab" />
          </div>
          <dispute-list-view
            v-if="cardType === 'list'"
            :employee-id="user.employeeId"
            :items="disputeRecords"
            :config-modal-is-open="isListViewConfigureModalOpen"
            :selected-rows="selectedRowsPerPage"
            @add-table-style="addTableClass"
            @onModalClose="openConfigModal"
            @onUpdateDisputeStatus="onUpdateDisputeStatus"
            @selectAllEvent="selectAllEvent"
            @selectChangeEvent="selectChangeEvent"
            @onSortColumns="sortRecordsByColumns" />
          <dispute-grid-view
            v-else
            :employee-id="user.employeeId"
            :items="disputeRecords"
            :disputes-constants="disputesConstants"
            :dispute-lookup-fields="disputeLookupFields"
            :dispute-chargecode-fields="disputeChargecodeFields"
            :resolution-rules="resolutionRules"
            :resolution-rules-loading="resolutionRulesLoading"
            :dispute-modal-loading="disputeModalLoading"
            :resolution-status-list="resolutionStatusList"
            :resolution-stages-list="resolutionStagesList"
            :resolution-button-values="resolutionButtonValues"
            :next-status-drop-down-list="nextStatusDropDownList"
            :resolution-modal-loading="resolutionModalLoading"
            :is-s-l-a-missed="isSLAMissed"
            :reason-for-delay-options="reasonForDelayOptions"
            @updateCaseDetails="updateDisputeRecords"
            @updateDisputes="updateDisputeRecords"
            @getCaseDetailsInfo="getCaseDetailsInfo"
            @getCaseDetailsStageStatusList="getCaseDetailsStageStatusList"
            @getCaseDetailsRulesList="getCaseDetailsRulesList"
            @fetchDisputeRecords="fetchDisputeRecords"
            @fetchVoiceDisputes="fetchVoiceDisputes"
            @isSLAMissedCheck="isSLAMissedCheck" />
        </div>
        <div
          v-else-if="!disputeRecords.length && !disputeRecordsLoading"
          class="dashboard-empty-state">
          <img
            src="https://cdn-assets-eu.frontify.com/s3/frontify-enterprise-files-eu/eyJwYXRoIjoibWFlcnNrXC9hY2NvdW50c1wvYmNcLzQwMDAxNDdcL3Byb2plY3RzXC8xMDdcL2Fzc2V0c1wvOGFcLzI1Mzc3XC84ZWQ3YzMwZWY2ZWU2M2Y2NWQ5YzYzNGZkYTVmZWMzYS0xNjAwODM2Njk0LnN2ZyJ9:maersk:pkaGBou0OgP5QfzjjC7Ib5HWKNyRyzfUugSXyKvXs3c?width=800"
            alt="No result found" />
          <h4 class="error-message add-footer-margin">No results found</h4>
        </div>
        <div class="pagination">
          <Pagination
            v-if="
              disputeRecordsCount &&
              disputeRecordsCount >= pagination.itemsPerPage
            "
            :total-items="disputeRecordsCount"
            :current-page="pagination.activePage"
            :page-size="pagination.itemsPerPage"
            :page-size-list="[50, 100, 150, 200]"
            :page-count="pageCount"
            @onPageChange="onChangePage"
            @onChangeItemsPerPage="onChangeItemsPerPage" />
        </div>
      </div>
    </div>
    <bulk-alert-message-modal
      v-if="showUpdateAlertModal || showBulkUpdateError"
      :messages="showBulkUpdateError ? bulkUpdateErrorMessage : bulkMessage"
      @onModalClose="onModalClose" />
    <dispute-case-details-modal
      v-else-if="
        disputeModalType === 'Update_casedetails' &&
        (resolutionStagesList || []).length &&
        (resolutionStatusList || []).length &&
        Object.keys(disputeLookupFields).length &&
        Object.keys(disputeChargecodeFields).length
      "
      :disputes-constants="disputesConstants"
      :dispute-lookup-fields="disputeLookupFields"
      :case-details="
        disputeSelectedRows.length
          ? disputeSelectedRows[0]
          : updateStatusFromListView
      "
      :bulk-data="disputeSelectedRows"
      :dispute-modal-loading="disputeModalLoading"
      :resolution-rules-loading="resolutionRulesLoading"
      :form-disabled-list="
        resolutionRules && resolutionRules.resolutionFormUIDisableList
      "
      :form-mandatory-list="
        resolutionRules && resolutionRules.resolutionFormUIValidationList
      "
      :resolution-status-list="resolutionStatusList"
      :resolution-stages-list="resolutionStagesList"
      :resolution-button-values="resolutionButtonValues"
      :selected-rows-length="disputeSelectedRows.length"
      :dispute-chargecode-fields="disputeChargecodeFields"
      :next-status-drop-down-list="nextStatusDropDownList"
      :is-s-l-a-missed="isSLAMissed"
      :reason-for-delay-options="reasonForDelayOptions"
      @getCaseDetailsStageStatusList="getCaseDetailsStageStatusList"
      @getCaseDetailsRulesList="getCaseDetailsRulesList"
      @onModalClose="onModalClose"
      @updateResolutionDisputeModal="updateResolutionDisputeModal"
      @saveComments="saveComments"
      @saveBulkComments="saveBulkComments"
      @createBulkVoiceDisputes="createBulkVoiceDisputes"
      @fetchVoiceDisputes="fetchVoiceDisputes"
      @isSLAMissedCheck="isSLAMissedCheck" />
    <dispute-assignee-modal
      v-else-if="disputeModalType === 'Update_assignee'"
      :is-bulk="true"
      :bulk-data="disputeSelectedRows"
      :dispute-modal-loading="disputeModalLoading"
      @saveComments="saveComments"
      @updateBulkAssigneeForm="updateBulkAssigneeForm"
      @saveBulkComments="saveBulkComments"
      @onModalClose="onModalClose" />
    <dispute-tender-modal
      v-else-if="disputeModalType === 'Update_tender'"
      :is-bulk="true"
      :bulk-data="disputeSelectedRows"
      :dispute-modal-loading="disputeModalLoading"
      @updateBulkTenderForm="updateBulkTenderForm"
      @saveBulkComments="saveBulkComments"
      @onModalClose="onModalClose" />
    <dispute-with-voice-modal
      v-else-if="disputeModalType === 'Update_voice_dispute_bulk'"
      :disputes-constants="disputesConstants"
      :dispute-selected-rows="disputeSelectedRows"
      :case-details="disputeSelectedRows[0]"
      @onModalClose="onModalClose"
      @createBulkVoiceDisputes="createBulkVoiceDisputes" />
    <dispute-contact-details-modal
      v-else-if="disputeModalType === 'Update_contact_details'"
      :dispute-selected-rows="disputeSelectedRows"
      :case-details="
        disputeSelectedRows.length === 1 ? disputeSelectedRows[0] : {}
      "
      @onModalClose="onModalClose"
      @updateBulkContactDetails="updateBulkContactDetails" />
    <share-filter
      :share-filter-modal-visible="shareFilterModalVisible"
      :applied-filters="filterDataByName"
      :share-filter-users-list="shareFilterUsersList"
      @on-close="onCloseShareFilterModal" />
    <export-excel-modal
      v-if="isExportExcelModalVisible"
      :configuration="exportConfigMapping.fieldMappings"
      :default-columns="defaultExportColumns"
      :filter-data="filterDataByName"
      :cache-name="filterCacheName"
      :pagination="pagination"
      :sort-order-configuration="sortOrderConfiguration"
      :records-count="disputeRecordsCount"
      :applied-search-term="appliedSearchTerm"
      @onModalClose="onExportModalClose" />

    <bulk-dispute-modal
      v-if="!isEmpty(bulkCreatedId) || isBulkStatusModalVisible"
      :enable-search="isEmpty(bulkCreatedId)"
      @onModalClose="onBulkModalClose">
    </bulk-dispute-modal>
    <auto-allocation-status-modal
      v-if="isAutoAllocationModalVisible"
      @onModalClose="onAutoAllocationModalClose" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Maersk Design System Components
import { FilterTags } from "@/components/common";

// Custom Components
import { showToast } from "@/components/common/Toast";
import FilterBar from "@/components/FilterBar/FilterBar.vue";
import ShareFilter from "@/components/FilterBar/ShareFilter.vue";
import DisputeListView from "@/components/DisputeListView/DisputeListView.vue";
import DisputeGridView from "@/components/DisputeGridView/DisputeGridView.vue";
import DashboardSkeleton from "@/components/Skeleton/DashboardSkeleton";
import DisputeCaseDetailsModal from "@/components/DisputeUpdateModals/DisputeCaseDetailsModal/DisputeCaseDetailsModal.vue";
import ExportExcelModal from "@/components/ExportExcelModal/ExportExcelModal.vue";
import DisputeWithVoiceModal from "@/components/DisputeUpdateModals/DisputeWithVoiceModal/DisputeWithVoiceModal.vue";
import DisputeContactDetailsModal from "@/components/DisputeUpdateModals/DisputeContactDetailsModal.vue";
import DisputeAssigneeModal from "@/components/DisputeUpdateModals/DisputeAssigneeModal.vue";
import DisputeTenderModal from "@/components/DisputeUpdateModals/DisputeTenderModal.vue";
import BulkAlertMessageModal from "@/components/DisputeUpdateModals/BulkAlertMessageModal.vue";
import Loading from "vue-loading-overlay";
import AutoAllocationStatusModal from "@/components/AutoAllocationStatusModal/AutoAllocationStatusModal.vue";
// Constants
import {
  disputeListViewBulkDropdownOptions,
  dashboardSortOptions,
  cacheNames,
  lookUpParameters,
  disputeStatusList,
} from "@/config/constant.js";

// Dispute Alert Messages
import {
  disputeBulkAlertMessage,
  redisputeAlertMessage,
  bulkUpdateAlertMessageOnTimeout,
  disputeStageMapping,
  statusCodesToEnableDwV,
  disputeStatusToEnableDwV,
} from "@/config/disputeUpdateModalConstant.js";

// Actions
import { disputeActions, userActions } from "@/actions";

// Helpers
import {
  debounce,
  scrollWindow,
  groupBy,
  filterGroupFlatten,
  getMsalIdToken,
  getMsalAccessToken,
  resetRelativeDateOnGivenFilter,
  isEmpty,
  getCaseAging,
  resolutionDropdownFields,
} from "@/utils/helpers.js";
import numeral from "numeral";

import BulkDisputeModal from "@/components/BulkDisputeModal/BulkDisputeModal.vue";

// Utils
import AxiosFetch from "@/utils/axios";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import {
  filterConfigMapping,
  defaultFilterColumns,
  numberOfCasesOptions,
} from "@/config/filterDataConstant";

export default {
  name: "Dashboard",
  components: {
    DashboardSkeleton,
    DisputeListView,
    DisputeGridView,
    FilterBar,
    ShareFilter,
    FilterTags,
    DisputeCaseDetailsModal,
    ExportExcelModal,
    DisputeWithVoiceModal,
    DisputeAssigneeModal,
    DisputeTenderModal,
    BulkAlertMessageModal,
    DisputeContactDetailsModal,
    Loading,
    BulkDisputeModal,
    AutoAllocationStatusModal,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    isBulkStatusModalVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    // FilterBar variables starts here
    const filtersAppliedCache = localStorage.getItem(
      `${cacheNames.filters}_for_applied_filter`
    );
    const filterDataByName = filtersAppliedCache
      ? groupBy(JSON.parse(filtersAppliedCache), "filterName")
      : {};
    const currentFilter = localStorage.getItem(
      `${cacheNames.filters}_for_applied_filter_title`
    );
    const currentFilterParsed = currentFilter
      ? JSON.parse(currentFilter)
      : { name: "", isEdited: false };
    const appliedSearchTerm = sessionStorage.getItem("appliedSearchTerm");
    const sortOrderConfigurationCache = localStorage.getItem(
      `${cacheNames.filters}_for_sort_order`
    );
    const sortOrderConfiguration = sortOrderConfigurationCache
      ? JSON.parse(sortOrderConfigurationCache)
      : {
          sortOrder: "",
          sortBy: "",
        };
    let customSortOrderName = localStorage.getItem("custom_sort_name");

    return {
      cardType: "grid",
      currentSelectedTab: "OPEN",
      disputeSort: {},
      disputeData: [],
      isListViewConfigureModalOpen: false,
      searchActive: false,
      searchTerm: "",
      sortOptions: dashboardSortOptions,
      numberOfDisputeCaseItems: 0,
      // FilterBar props starts here
      shareFilterModalVisible: false,
      shareFilterUsersList: [],
      isFilterOpen: false,
      filterConfigMapping: filterConfigMapping,
      exportConfigMapping: { ...filterConfigMapping },
      filterDataByName: filterDataByName,
      defaultFilterColumns: defaultFilterColumns,
      defaultExportColumns: [...defaultFilterColumns],
      filterCacheName: cacheNames.filters,
      savedFilterPreferences: [],
      filterPreferenceList: [],
      currentFilter: currentFilterParsed,
      filterFacets: [],
      disputeRecords: [],
      disputeRecordsFacets: {},
      disputeRecordsCount: 0,
      disputeRecordsCountFormatted: "",
      disputeRecordsLoading: true,
      disputeRecordsError: false,
      isSavedFiltersLoading: true,
      isFiltersEmpty: !filtersAppliedCache,
      equipmentData: [],
      filterData: {},
      pagination: {
        activePage: 1,
        itemsPerPage: 50,
      },
      appliedSearchTerm: appliedSearchTerm,
      facetSearchTerm: "",
      selectedFacetFieldName: "",
      sortOrderConfiguration: sortOrderConfiguration,
      selectedSort: customSortOrderName
        ? `Custom: ${customSortOrderName}`
        : null,
      selectedSortWithoutTruncate: customSortOrderName
        ? `Custom: ${customSortOrderName} ${sortOrderConfiguration.sortOrder?.toUpperCase()}`
        : "default",
      facetToSkip: "",
      disputeSelectedRowsByPage: {},
      disputeSelectedRows: [],
      selectedRowsPerPage: [],
      // FilterBar props ends here
      sortFilterBy: "",
      tableClassName: "",
      updateStatusFromListView: false,
      disputeModalLoading: false,
      isExportExcelModalVisible: false,
      selectOptions: disputeListViewBulkDropdownOptions,
      disputeModalType: "",
      // Resolution props starts here
      lookUpParameters,
      disputesConstants: {},
      disputeStatusList: disputeStatusList,
      disputeLookupFields: {},
      disputeChargecodeFields: {},
      resolutionButtonValues: [],
      resolutionRules: {},
      resolutionRulesLoading: false,
      resolutionModalLoading: false,
      resolutionStatusList: [],
      resolutionStagesList: [],
      disputeBulkAlertMessage: disputeBulkAlertMessage,
      bulkUpdateAlertMessageOnTimeout: bulkUpdateAlertMessageOnTimeout,
      redisputeAlertMessage: redisputeAlertMessage,
      nextStatusDropDownList: [],
      showUpdateAlertModal: false,
      bulkUpdateTimeout: false,
      showBulkUpdateError: false,
      bulkUpdateErrorMessage: "",
      isSLAMissed: null,
      bulkCreatedId: localStorage.getItem("bulk_create_id"),
      reasonForDelayOptions: [],
      selectedCasesCount: { value: "", label: "Select Number of cases" },
      assignedDisputeList: [],
      numberOfCasesOptions: numberOfCasesOptions,
      isAutoAllocationModalVisible: false,
    };
  },
  computed: {
    ...mapGetters(["getIsEditor"]),
    ...mapGetters(["getIsSupport"]),
    pageCount() {
      let count = Math.ceil(
        this.disputeRecordsCount / this.pagination.itemsPerPage
      );
      return count > 2000 ? 2000 : count;
    },
    paginationStartCount() {
      return this.pagination.activePage === 1
        ? this.pagination.activePage
        : this.pagination.activePage * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage +
            1;
    },
    paginationEndCount() {
      return this.pagination.activePage * this.pagination.itemsPerPage;
    },
    searchRecordsWatch() {
      return {
        filterDataByName: this.filterDataByName,
        appliedSearchTerm: this.appliedSearchTerm,
        sortOrderConfiguration: this.sortOrderConfiguration,
        currentSelectedTab:
          this.currentSelectedTab !== "ALL" ? this.currentSelectedTab : "",
      };
    },
    facetSearchTermWatch() {
      return {
        filterDataByName: this.filterDataByName,
        facetSearchTerm: this.facetSearchTerm,
        sortOrderConfiguration: this.sortOrderConfiguration,
        currentSelectedTab:
          this.currentSelectedTab !== "ALL" ? this.currentSelectedTab : "",
      };
    },
    searchActiveClass() {
      return this.searchActive ? "search-active" : "";
    },
    switchViewText() {
      return `Switch to ${this.cardType === "grid" ? "table" : "grid"} view`;
    },
    bulkMessage() {
      if (this.bulkUpdateTimeout) {
        return this.bulkUpdateAlertMessageOnTimeout;
      } else {
        return this.updateStatusFromListView?.disputeStage?.toLowerCase() ===
          "redispute"
          ? this.redisputeAlertMessage
          : this.disputeBulkAlertMessage;
      }
    },
    bulkUpdateValue() {
      const selectedItem =
        this.selectOptions.filter(
          (item) => item.value === this.disputeModalType
        ) || [];
      return selectedItem.length ? selectedItem[0] : this.selectOptions[0];
    },
    getSortOptions() {
      if (this.sortOrderConfiguration.sortBy) {
        return [
          { value: "Default", label: "Default" },
          { value: `${this.selectedSort}`, label: `${this.selectedSort}` },
        ];
      }
      return [{ value: "Default", label: "Default" }];
    },
    selectedSortOption() {
      return this.selectedSort
        ? { value: `${this.selectedSort}`, label: `${this.selectedSort}` }
        : {};
    },
    getSelectOptions() {
      if (this.getIsSupport && this.getIsEditor) {
        return this.selectOptions;
      } else if (this.getIsSupport) {
        return this.selectOptions.filter(
          (item) => item.value === "Update_tender" || item.value === ""
        );
      } else {
        return this.selectOptions.filter(
          (item) => item.value !== "Update_tender"
        );
      }
    },
    bulkEditDisabled() {
      if (this.getIsSupport || this.getIsEditor) {
        return false;
      }
      return true;
    },
    disputeSearchInputError() {
      return !!this.searchTerm.length && this.searchTerm.length > 500;
    },
  },
  watch: {
    disputeRecords() {
      this.numberOfDisputeCaseItems = this.disputeRecords.length || 0;
    },
    assignedDisputeList() {
      this.numberOfCasesOptions = numberOfCasesOptions?.slice(
        0,
        11 - this?.assignedDisputeList?.length
      );
      if (!this.numberOfCasesOptions?.length) {
        this.numberOfCasesOptions = numberOfCasesOptions?.slice(0, 11 - 10);
      }
    },
    filterDataByName() {
      const filters = filterGroupFlatten(this.filterDataByName);
      this.isFiltersEmpty = !filters.length;
      if (this.isFiltersEmpty) {
        this.currentFilter = {
          name: "",
          isEdited: false,
        };
      }
      this.resetRowSelection();
      this.selectedRowsInPage();
    },
    searchRecordsWatch() {
      this.debounceFetchAllDisputes();
      this.triggerFetchFacet();
    },
    pagination: {
      deep: true,
      handler() {
        this.debounceFetchAllDisputes();
      },
    },
    facetSearchTermWatch() {
      this.debounceTriggerFetchFacet("facet_search");
    },
    currentFilter() {
      if (this.currentFilter) {
        localStorage.setItem(
          `${this.filterCacheName}_for_applied_filter_title`,
          JSON.stringify(this.currentFilter)
        );
      } else {
        localStorage.removeItem(
          `${this.filterCacheName}_for_applied_filter_title`
        );
      }
    },
    sortOrderConfiguration(configuration) {
      localStorage.setItem(
        `${cacheNames.filters}_for_sort_order`,
        JSON.stringify(configuration)
      );
    },
  },
  mounted() {
    const filedMappingsCached = localStorage.getItem(
      `${this.filterCacheName}_for_columns"`
    );
    if (filedMappingsCached) {
      this.filterConfigMapping.fieldMappings = JSON.parse(filedMappingsCached);
    }

    if (this.isFilterOpen) {
      this.toggleFilterBodyClass("addClass", "filter-visible");
    }

    let visibleFilterKeys = Object.values(
      this.filterConfigMapping.fieldMappings
    ).filter((item) => item.isVisible);
    const filterFacets = [];
    visibleFilterKeys.forEach((item) => {
      filterFacets.push({ property_id: item.fieldName });
    });
    this.filterFacets = [...filterFacets];
    const filterIdByQueryParam = this.$router.currentRoute.query.filter_id;
    this.onInitialize(filterIdByQueryParam);
    if (!filterIdByQueryParam) {
      this.fetchAllDisputes();
    }

    // Loading Disputes
    this.fetchDisputeConstantFields();
    this.fetchDisputeLookupFields();
    this.fetchDisputeChargeCodeFields();

    //Loading Bulk Dispute Modal
    if (!isEmpty(localStorage.getItem("bulk_create_id"))) {
      this.bulkCreatedId = localStorage.getItem("bulk_create_id");
    }

    //Loading Assigned Dispute cases
    this.getAssignedDisputeList();
  },
  destroyed() {
    this.toggleFilterBodyClass("removeClass", "filter-visible");
  },
  methods: {
    onBulkModalClose() {
      if (isEmpty(this.bulkCreatedId)) {
        this.$emit("toggleBulkStatusModal");
      } else {
        localStorage.removeItem("bulk_create_id");
        this.bulkCreatedId = "";
        this.updateDisputeRecords();
      }
    },
    isEmpty,
    showLoader(container) {
      this.loader = this.$loading.show({
        container: container ? this.$refs[container] : undefined,
        canCancel: false,
        onCancel: this.onCancel,
        color: "#0573ab",
        isFullPage: container ? false : true,
      });
    },
    hideLoader() {
      this.loader.hide();
    },
    debounceTriggerFetchFacet: debounce(function (value) {
      this.triggerFetchFacet(value);
    }, 350),
    debounceFetchAllDisputes: debounce(function () {
      this.fetchAllDisputes();
    }, 350),
    triggerFetchFacet(value = "default_search") {
      if (this.isFilterOpen) {
        const fieldKeys = Object.keys(this.filterConfigMapping.fieldMappings);
        if (value === "facet_search") {
          fieldKeys.forEach((filter) => {
            if (
              this.filterConfigMapping.fieldMappings[filter].expanded &&
              this.filterConfigMapping.fieldMappings[filter].type ===
                "checkbox" &&
              this.filterConfigMapping.fieldMappings[filter].fieldName !==
                this.facetToSkip &&
              this.filterConfigMapping.fieldMappings[filter].fieldName ===
                this.selectedFacetFieldName
            ) {
              this.fetchFacet(
                this.filterConfigMapping.fieldMappings[filter].fieldName,
                this.selectedFacetFieldName
              );
              this.facetToSkip = "";
            }
          });
        } else {
          fieldKeys.forEach((filter) => {
            if (
              this.filterConfigMapping.fieldMappings[filter].expanded &&
              this.filterConfigMapping.fieldMappings[filter].type ===
                "checkbox" &&
              this.filterConfigMapping.fieldMappings[filter].fieldName !==
                this.facetToSkip
            ) {
              this.fetchFacet(
                this.filterConfigMapping.fieldMappings[filter].fieldName
              );
              this.facetToSkip = "";
            }
          });
        }
      }
    },
    onUpdateDisputeStatus(selectedRow) {
      this.updateStatusFromListView = selectedRow;
      if (selectedRow?.disputeStage?.toLowerCase() === "redispute") {
        this.showUpdateAlertModal = true;
      } else {
        if (this.disputeSelectedRows?.length > 1) {
          this.handleMultiActionSelect({ value: "Update_casedetails" });
        } else {
          this.getCaseDetailsInfo(selectedRow);
          this.disputeModalType = "Update_casedetails";
        }
      }
    },
    async onInitialize(filterIdByQueryParam) {
      if (filterIdByQueryParam) {
        const opts = userActions.getShareFilter(
          filterIdByQueryParam,
          `Bearer ${await getMsalIdToken(this)}`,
          `Bearer ${await getMsalAccessToken(this)}`
        );

        try {
          const {
            data: { filter_json },
          } = await AxiosFetch(opts);
          let filterJSON = JSON.parse(filter_json);

          if (filterJSON) {
            filterJSON = resetRelativeDateOnGivenFilter(filterJSON);
            this.filterDataByName = filterJSON || {};
            this.currentFilter = {
              name: "",
              isEdited: true,
            };
            showToast("success", "Shared filters has been applied.");
          }
          this.$router.replace({ filter_id: null });
        } catch (error) {
          console.error(error);
          showToast(
            "error",
            "Unable to fetch the shared filter, please try reloading page"
          );
        }
      }
    },
    addTableClass(className) {
      this.tableClassName = className;
    },
    handleViewChange() {
      this.cardType = this.cardType !== "grid" ? "grid" : "list";
    },
    handleListViewConfigureModal() {
      this.isListViewConfigureModalOpen = !this.isListViewConfigureModalOpen;
    },
    openConfigModal(value) {
      this.isListViewConfigureModalOpen = value;
    },
    async fetchAllDisputes() {
      this.disputeRecordsError = false;
      this.disputeRecordsLoading = true;
      let filters = filterGroupFlatten(this.filterDataByName);
      const {
        idTokenClaims: { EmployeeID: employeeId },
      } = this.$store.getters.getTokenData;
      // Store the applied fitler data to localstorage if exist or else remove the item from localstorage
      if (
        this.$route?.params?.data ||
        JSON.parse(localStorage.getItem("liveDashboardData") || '""')
      ) {
        filters = [
          {
            property_id: "ohpDisputeId",
            values: [
              ...(this?.$route?.params?.data ||
                JSON.parse(localStorage.getItem("liveDashboardData") || '""')),
            ],
            filterName: "OHP Dispute id",
            type: "EXACT_MATCH",
            exclude: false,
            updatable: true,
          },
        ];
        // if (
        //   this?.$route?.params?.managerView ||
        //   JSON.parse(localStorage.getItem("managerView") || '""')
        // ) {
        //   filters.push({
        //     property_id: "processorName",
        //     values: [`${employeeId}`],
        //     filterName: "Processor name",
        //     type: "EXACT_MATCH",
        //     exclude: false,
        //     updatable: true,
        //   });
        // }
        this.$router.replace({ params: {} });
        localStorage.setItem(
          `${this.filterCacheName}_for_applied_filter`,
          filters?.length ? JSON.stringify(filters) : ""
        );
        this.disputeRecordsLoading = false;
        window.location.reload();
      } else if (
        filters?.length &&
        (!this?.$route?.params?.data ||
          !JSON.parse(localStorage.getItem("liveDashboardData") || '""'))
      ) {
        localStorage.setItem(
          `${this.filterCacheName}_for_applied_filter`,
          filters?.length ? JSON.stringify(filters) : ""
        );
      } else {
        localStorage.removeItem(`${this.filterCacheName}_for_applied_filter`);
      }

      localStorage.removeItem(`liveDashboardData`);
      localStorage.removeItem(`managerView`);

      const searchRequestPayload = disputeActions.getDisputeList(
        {
          params: {
            page_no: this.pagination.activePage - 1,
            page_size: this.pagination.itemsPerPage,
          },
          data: {
            object_id: "disputes-view",
            filters,
            search: this.appliedSearchTerm,
            sort_by: this.sortOrderConfiguration.sortBy
              ? this.sortOrderConfiguration.sortBy
              : "changedTs",
            sort_order: this.sortOrderConfiguration.sortOrder
              ? this.sortOrderConfiguration.sortOrder
              : "DESC",
          },
        },
        await getMsalIdToken(this)
      );

      try {
        const {
          data: { search_records, count },
        } = await AxiosFetch(searchRequestPayload);
        this.disputeRecords = search_records ? [...search_records] : [];
        this.addCaseAging([...search_records]);
        this.disputeRecordsCount = count;
        this.disputeRecordsCountFormatted = (
          numeral(count)
            .format("0.00a")
            .replace(/[^0-9.]/g, "") %
            1 !=
          0
            ? numeral(count).format("0.00a")
            : numeral(count).format("0a")
        ).toUpperCase();
        this.disputeRecordsError = false;
        this.disputeRecordsLoading = false;
        scrollWindow();
      } catch (error) {
        console.error(error);
        this.disputeRecords = [];
        this.disputeRecordsError = true;
        this.disputeRecordsLoading = false;
      }
    },
    async fetchFacet(property_id, facet_name) {
      const filterConfigMapping = { ...this.filterConfigMapping };

      let facetName = "";
      const fieldKeys = Object.keys(filterConfigMapping.fieldMappings);

      fieldKeys.forEach((key) => {
        if (filterConfigMapping.fieldMappings[key].fieldName === property_id) {
          facetName = key;
        }
      });
      filterConfigMapping.fieldMappings[facetName].isLoading = true;

      this.filterConfigMapping = filterConfigMapping;

      const filters = filterGroupFlatten(this.filterDataByName);

      const currentFacetIndex = filters.findIndex(
        (filter) => filter.property_id === property_id
      );
      if (currentFacetIndex > -1) {
        filters.splice(currentFacetIndex, 1);
      }

      const facetsRequestPayload = disputeActions.getDisputeFacet(
        {
          params: {
            count: 500,
            search:
              facet_name === this.selectedFacetFieldName
                ? this.facetSearchTerm
                : "",
          },
          data: {
            object_id: "dispute-task",
            filters,
            search: this.appliedSearchTerm,
            ...(this.sortOrderConfiguration.sortBy && {
              sort_by: this.sortOrderConfiguration.sortBy,
            }),
            ...(this.sortOrderConfiguration.sortOrder && {
              sort_order: this.sortOrderConfiguration.sortOrder,
            }),
          },
          property_id,
        },
        await getMsalIdToken(this)
      );

      try {
        const {
          data: { facets },
        } = await AxiosFetch(facetsRequestPayload);
        const disputeRecordsFacets = { ...this.disputeRecordsFacets };
        disputeRecordsFacets[property_id] = facets ? facets[property_id] : [];
        this.disputeRecordsFacets = disputeRecordsFacets;
      } catch (error) {
        console.error(error);
      }
      filterConfigMapping.fieldMappings[facetName].isLoading = false;
      this.filterConfigMapping = filterConfigMapping;
    },
    async sortRecordsByColumns(property, order, title) {
      const sortOrderConfiguration = { ...this.sortOrderConfiguration };
      this.selectedSort = `Custom: ${title} ${order.toUpperCase()}`.substring(
        0,
        18
      );
      this.selectedSortWithoutTruncate = `Custom: ${title} ${order.toUpperCase()}`;
      sortOrderConfiguration.sortOrder = order.toUpperCase();
      sortOrderConfiguration.sortBy =
        property === "case_aging" ? "createdTs" : property;

      this.sortOrderConfiguration = sortOrderConfiguration;
      localStorage.setItem("custom_sort_name", title);
    },
    toggleFilterBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    onFilterToggle() {
      const filterVisibility = !this.isFilterOpen;
      this.isFilterOpen = filterVisibility;
      if (this.isFilterOpen) {
        const fieldKeys = Object.keys(this.filterConfigMapping.fieldMappings);

        fieldKeys.forEach((filter) => {
          if (
            this.filterConfigMapping.fieldMappings[filter].expanded &&
            this.filterConfigMapping.fieldMappings[filter].type === "checkbox"
          ) {
            this.fetchFacet(
              this.filterConfigMapping.fieldMappings[filter].fieldName
            );
          }
        });
      }
      this.toggleFilterBodyClass(
        filterVisibility ? "addClass" : "removeClass",
        "filter-visible"
      );
    },
    onFilterCardToggle(cardName) {
      const filterConfigMappingUpdated = { ...this.filterConfigMapping };
      filterConfigMappingUpdated.fieldMappings[cardName].expanded =
        !filterConfigMappingUpdated.fieldMappings[cardName].expanded;
      this.filterConfigMapping = filterConfigMappingUpdated;
      if (
        filterConfigMappingUpdated.fieldMappings[cardName].expanded &&
        filterConfigMappingUpdated.fieldMappings[cardName].type === "checkbox"
      ) {
        this.onFacetOpen(
          filterConfigMappingUpdated.fieldMappings[cardName].fieldName
        );
      }
    },
    onFilterCheckboxSelect(isChecked, selectedValue, selectedKey, fieldData) {
      const filterDataByName = { ...this.filterDataByName };
      if (this.filterDataByName[selectedKey]?.length) {
        const newOption = [...filterDataByName[selectedKey]];
        if (isChecked) {
          newOption[0].values.push(selectedValue);
        } else {
          if (newOption[0].values.length) {
            newOption[0].values.splice(
              newOption[0].values.indexOf(selectedValue),
              1
            );
          } else {
            newOption[0].values = [];
          }
        }
        filterDataByName[selectedKey] = newOption;
        this.filterDataByName = filterDataByName;
      } else {
        const newOption = [
          {
            property_id: fieldData.fieldName,
            values: [selectedValue],
            filterName: selectedKey,
            type: "EXACT_MATCH",
            exclude: false,
            updatable: true,
          },
        ];
        filterDataByName[selectedKey] = newOption;
        this.filterDataByName = filterDataByName;
      }
      this.setFilterModified(true);
      this.facetToSkip = fieldData.fieldName;
    },
    onCheckboxMultiSelect(
      selectionType,
      selectedKey,
      fieldData,
      selectedOptions
    ) {
      let selectedValues;
      if (selectionType === "selectAll") {
        selectedValues = selectedOptions;
      } else {
        selectedValues = [];
      }

      const newOption = [
        {
          property_id: fieldData.fieldName,
          values: selectedValues,
          filterName: selectedKey,
          type: "EXACT_MATCH",
          exclude: false,
          updatable: true,
        },
      ];
      const filterDataByName = { ...this.filterDataByName };
      filterDataByName[selectedKey] = newOption;
      this.filterDataByName = filterDataByName;
      this.setFilterModified(true);
      this.facetToSkip = fieldData.fieldName;
    },
    onDateSelect(newOptions, selectedKey) {
      const filterDataByName = { ...this.filterDataByName };
      if (!newOptions) {
        delete filterDataByName[selectedKey];
      } else {
        filterDataByName[selectedKey] = newOptions;
      }
      this.filterDataByName = filterDataByName;
      this.setFilterModified(true);
      this.facetToSkip = "";
    },
    onSaveColumnConfig(newConfiguration) {
      this.filterConfigMapping.fieldMappings = newConfiguration;
    },
    onApplySavedFilter(selectedFilter) {
      const filterPreference = JSON.parse(
        selectedFilter.filter_preference_json
      );
      let filterData = groupBy(filterPreference.filters, "filterName");
      this.currentFilter = {
        name: selectedFilter.label,
        isEdited: false,
      };
      if (filterData) {
        filterData = resetRelativeDateOnGivenFilter(filterData);
      }
      this.filterDataByName = filterData;
      this.setActivePage(1);
      this.appliedSearchTerm = "";
    },
    async onSaveNewFilter(selectedFilter, isUpdate, onSaveCB) {
      const savedFilterPreferences = [...this.savedFilterPreferences];
      const filterPreferenceList = [...this.filterPreferenceList];
      const fitlerValues = {
        filters: [],
      };

      fitlerValues.filters = Object.keys(this.filterDataByName).map(
        (i) => this.filterDataByName[i][0]
      );
      const filterPreferencePayload = {
        filter_title: selectedFilter,
        filter_preference_json: JSON.stringify(fitlerValues),
      };

      this.savingNewFilter = true;

      try {
        const payload = await userActions.saveFilterPreference(
          filterPreferencePayload,
          isUpdate,
          `Bearer ${await getMsalIdToken(this)}`,
          `Bearer ${await getMsalAccessToken(this)}`
        );
        await AxiosFetch(payload);

        if (isUpdate) {
          const filterIndex = this.filterPreferenceList.findIndex(
            (i) => i.filter_title === selectedFilter
          );
          if (filterIndex > -1) {
            filterPreferenceList[filterIndex] = {
              filter_title: selectedFilter,
              filter_preference_json: JSON.stringify(fitlerValues),
            };
          }
        } else {
          filterPreferenceList.push({
            filter_title: selectedFilter,
            filter_preference_json: JSON.stringify(fitlerValues),
          });
          savedFilterPreferences.push({
            label: selectedFilter,
            value: selectedFilter,
          });
        }
        onSaveCB(true);
        showToast("success", "Filter has been saved successfully!");
        this.filterPreferenceList = filterPreferenceList;
        this.savedFilterPreferences = savedFilterPreferences;
        this.currentFilter = {
          name: selectedFilter,
          isEdited: false,
        };
      } catch (err) {
        showToast(
          "error",
          `${
            err?.response?.data?.message ||
            "Unable to save filter, please try again!"
          }`
        );
        onSaveCB(false);
        this.savingNewFilter = false;
      }
    },
    onFilterClear() {
      this.filterDataByName = {};
      this.setActivePage(1);
      localStorage.removeItem(`${cacheNames.filters}_for_applied_filter`);
      localStorage.removeItem(`${cacheNames.filters}_for_applied_filter_title`);
    },
    onFacetOpen(property_id) {
      this.fetchFacet(property_id);
    },
    async fetchFilterPreference() {
      this.shareFilterModalVisible = false;
      const payload = await userActions.getFilterPreference(
        `Bearer ${await getMsalIdToken(this)}`,
        `Bearer ${await getMsalAccessToken(this)}`
      );
      this.isSavedFiltersLoading = true;
      try {
        const {
          data: { filter_preferences },
        } = await AxiosFetch(payload);
        this.filterPreferenceList = filter_preferences || [];
        const savedFilterPreferences =
          filter_preferences &&
          filter_preferences.map((filter) => {
            return {
              ...filter,
              label: filter.filter_title,
              value: filter.filter_title,
            };
          });
        this.savedFilterPreferences = savedFilterPreferences || [];
        this.isSavedFiltersLoading = false;
      } catch (err) {
        console.error(err);
        this.isSavedFiltersLoading = false;
      }
    },
    async onSavedFilterModalOpen() {
      const payload = await userActions.getFilterPreference(
        `Bearer ${await getMsalIdToken(this)}`,
        `Bearer ${await getMsalAccessToken(this)}`
      );
      this.isSavedFiltersLoading = true;
      try {
        const {
          data: { filter_preferences },
        } = await AxiosFetch(payload);
        this.filterPreferenceList = filter_preferences || [];
        const savedFilterPreferences = filter_preferences.map((filter) => {
          return {
            ...filter,
            label: filter.filter_title,
            value: filter.filter_title,
          };
        });
        this.savedFilterPreferences = savedFilterPreferences || [];
        this.isSavedFiltersLoading = false;
      } catch (err) {
        console.error(err);
        this.isSavedFiltersLoading = false;
      }
    },
    onRemoveFilter(name) {
      const filterDataByName = { ...this.filterDataByName };
      delete filterDataByName[name];
      this.filterDataByName = filterDataByName;
      this.setActivePage(1);
      this.setFilterModified(true);
    },
    onSearch(e) {
      const search = e.target.value;
      this.searchTerm = search;
      if ((!search.length || search.length >= 3) && search.length <= 500) {
        this.appliedSearchTerm = search;
        this.resetRowSelection();
        this.selectedRowsInPage();
        this.setActivePage(1);
      }
    },
    onFetchSearchResults: debounce(async (keyword, vm) => {
      vm.searchTerm = keyword;
      if (!keyword.length || keyword.length >= 3) {
        vm.appliedSearchTerm = keyword;
      }
      vm.setActivePage(1);
    }, 350),
    onSort({ value }) {
      this.sortFilterBy = value;
    },
    setActivePage(activePage) {
      const pagination = { ...this.pagination };
      pagination.activePage = activePage;
      this.pagination = pagination;
      this.facetToSkip = "";
    },
    onChangePage(selected) {
      this.setActivePage(selected);
      this.fetchAllDisputes();
      this.resetRowSelection();
      this.selectedRowsInPage();
    },
    setFilterModified(isEdited) {
      const currentFilter = { ...this.currentFilter };
      this.currentFilter = {
        ...currentFilter,
        isEdited: isEdited,
      };
      this.setActivePage(1);
      this.resetRowSelection();
    },
    // Disupte Resolution methods starts here
    async fetchResolutionStageStatusList(selectedDispute, nextStage) {
      try {
        this.resolutionRulesLoading = true;
        let disputeStage = nextStage || selectedDispute?.disputeStage;
        if (!disputeStage) {
          disputeStageMapping &&
            Object.keys(disputeStageMapping).forEach((item) => {
              if (selectedDispute?.statusCode === item) {
                disputeStage = disputeStageMapping[item];
              }
            });
        }

        const { data } =
          disputeStage &&
          (await AxiosFetchForMsal(
            disputeActions.getDisputeResolutionStageList(
              await getMsalIdToken(this),
              disputeStage,
              selectedDispute?.isRedisputed || false
            )
          ));
        this.nextStatusDropDownList = data?.nextStatusDropDown?.length
          ? data?.nextStatusDropDown.filter(
              (item) =>
                item.id != 68 && item.id != 69 && item.id != 70 && item.id != 79
            )
          : [];
        let resolutionStatusList = this.nextStatusDropDownList?.length
          ? this.nextStatusDropDownList?.map((value) => {
              const statusDescription = value?.description;
              return {
                id: value?.id.toString(),
                value: statusDescription,
                label: statusDescription,
              };
            })
          : [
              {
                id: 2,
                label: `${selectedDispute?.statusCode}: ${selectedDispute?.statusDescription}`,
                value: `${selectedDispute?.statusCode}: ${selectedDispute?.statusDescription}`,
              },
            ];
        resolutionStatusList = [
          {
            id: "select",
            displayName: "Select",
            label: "Select",
            value: "",
          },
          ...resolutionStatusList,
        ];

        const resolutionStages = data?.disputeStageDropDown?.map((value) => {
          return {
            value: value,
            label: value,
          };
        });
        this.resolutionStatusList = resolutionStatusList;
        this.resolutionStagesList = !nextStage
          ? resolutionStages
          : this.resolutionStagesList;
        this.resolutionButtonValues = data?.buttonsDropDown;
        this.resolutionRulesLoading = false;
      } catch (error) {
        this.disputeModalType = "";
        this.resolutionRulesLoading = false;
        showToast(
          "error",
          "Unable to fetch the dispute case details, Please try after sometime."
        );
        console.error(error);
      }
    },
    async getCategoriesMenuItem() {
      try {
        this.resolutionRulesLoading = true;
        const { data } = await AxiosFetchForMsal(
          disputeActions.getCategoriesMenuItem(
            "reasonForDelayOptions",
            "Dispute",
            "Ocean",
            await getMsalIdToken(this)
          )
        );
        let reasonForDelayList = data
          ?.map((item) => {
            return {
              id: item?.itemValue?.replace(/\s+/g, " "),
              label: item?.itemValue?.replace(/\s+/g, " "),
              value: item?.itemValue?.replace(/\s+/g, " "),
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by 'label';
        this.reasonForDelayOptions = [
          {
            id: "select",
            label: "Select",
            value: "",
          },
          ...reasonForDelayList,
        ];
        this.resolutionRulesLoading = false;
      } catch (error) {
        this.disputeModalType = "";
        this.resolutionRulesLoading = false;
        console.error(
          "Unable to Fetch Reason ForDelayOptions. please try again"
        );
      }
    },
    async fetchDisputeResolutionRules(selectedDispute, nextStatusId) {
      try {
        this.resolutionRulesLoading = true;
        const { data } = await AxiosFetchForMsal(
          disputeActions.getDisputeResolutionRules(
            await getMsalIdToken(this),
            selectedDispute?.statusCode,
            selectedDispute?.isRedisputed || false,
            nextStatusId
          )
        );
        this.resolutionRules = data;
        this.resolutionRulesLoading = false;
      } catch (error) {
        this.disputeModalType = "";
        this.resolutionRulesLoading = false;
        showToast(
          "error",
          "Unable to fetch the dispute case details, Please try after sometime."
        );
        console.error(error);
      }
    },
    async isSLAMissedCheck(payload) {
      try {
        this.resolutionRulesLoading = true;
        const data = this.disputeSelectedRows.length
          ? this.disputeSelectedRows
          : payload.selectedDispute;
        const bulkDisputeValidatePayload = data.map((item) => ({
          ohpDisputeId: item.ohpDisputeId,
          countryCode: item.countryCode,
          createdTs: item.createdTs,
          lastDisputedTs: item.lastDisputeTs,
          closedTs: item.closedTs,
          resolutionDelayReason: "Not Applicable",
          isDwV: item.isDwV || false,
        }));
        await AxiosFetchForMsal(
          disputeActions.validateBulkDispute(
            { data: bulkDisputeValidatePayload },
            await getMsalIdToken(this)
          )
        );
        this.isSLAMissed = false;
        this.resolutionRulesLoading = false;
      } catch (err) {
        this.isSLAMissed = true;
        this.resolutionRulesLoading = false;
      }
    },
    async fetchDisputeConstantFields() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.disputeFieldConstants(await getMsalIdToken(this))
        );
        this.disputesConstants = resolutionDropdownFields(data, true); // true(fromConstantApi)
      } catch (error) {
        console.error(error);
      }
    },
    async fetchDisputeLookupFields() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.disputeFieldLookups(
            await getMsalIdToken(this),
            lookUpParameters
          )
        );
        this.disputeLookupFields = resolutionDropdownFields(data);
      } catch (error) {
        console.error(error);
      }
    },
    async fetchDisputeChargeCodeFields() {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getChargeCodeDropdownValues(await getMsalIdToken(this))
        );
        this.disputeChargecodeFields = resolutionDropdownFields(data);
      } catch (err) {
        console.error(err);
      }
    },
    async updateResolutionDisputeModal(
      payload,
      fromBulk,
      successCallback,
      bulkDisputeValidatePayload
    ) {
      try {
        this.showLoader();
        if (fromBulk) {
          const data = await AxiosFetchForMsal(
            disputeActions.updateBulkDisputes(
              payload,
              await getMsalIdToken(this)
            )
          );

          if (data?.status === 200 && data?.data?.length) {
            showToast("success", `Success`);
            localStorage.setItem("bulk_create_id", data?.data);
            this.bulkCreatedId = data?.data;
          } else {
            showToast(
              "error",
              "Failed to update the disputes, please try again"
            );
          }

          this.disputeModalLoading = false;
          this.hideLoader();
          this.onModalClose();
        } else {
          await AxiosFetchForMsal(
            disputeActions.updateResolutionDisputeDetails(
              this.updateStatusFromListView?.ohpDisputeId,
              payload,
              await getMsalIdToken(this)
            )
          );
          await this.updateDisputeRecords();
          this.hideLoader();
          showToast("success", "Dispute updated successfully!");
          if (typeof successCallback === "function") {
            successCallback();
          } else {
            this.disputeModalType = "";
          }
        }
      } catch (err) {
        this.hideLoader();
        this.onModalClose();
        console.error(err);
        if (fromBulk && err.message === "Request failed with status code 504") {
          this.bulkUpdateTimeout = true;
          this.showUpdateAlertModal = true;
        } else if (
          err.errorMessage === "Resolution delay reason is mandatory"
        ) {
          showToast(
            "error",
            "SLA is missed for this dispute, please provide a delay reason other than 'Not Applicable' in order to close this case."
          );
        } else if (
          err?.response?.data?.errorMessage != "" ||
          err?.response?.data?.errorMessage != null ||
          err?.response?.data?.errorMessage != undefined
        ) {
          showToast("error", err?.response?.data?.errorMessage);
        } else {
          showToast("error", "Failed to update the disputes, please try again");
        }
      }
    },
    async getCaseDetailsInfo(selectedDispute) {
      this.resolutionModalLoading = true;
      await Promise.all([
        this.fetchDisputeResolutionRules(selectedDispute),
        this.fetchResolutionStageStatusList(selectedDispute),
        this.getCategoriesMenuItem(),
      ]).then(() => {
        this.resolutionModalLoading = false;
      });
    },
    getCaseDetailsStageStatusList(selectedDispute, nextStage) {
      this.fetchResolutionStageStatusList(selectedDispute, nextStage);
    },
    getCaseDetailsRulesList(selectedDispute, nextStatusId) {
      this.fetchDisputeResolutionRules(selectedDispute, nextStatusId);
    },
    // Disupte Resolution methods ends here
    fetchDisputeRecords() {
      this.updateStatusFromListView = false;
      this.fetchAllDisputes();
    },
    onCloseShareFilterModal() {
      this.shareFilterModalVisible = false;
    },
    async onShareFilterModal() {
      this.shareFilterModalVisible = true;
      this.isFilterVisible = false;
      this.openSaveFilter = false;

      // Fetching the users to share the filter with
      try {
        const opts = userActions.getUserList(
          {},
          `Bearer ${await getMsalIdToken(this)}`
        );
        const {
          data: { value },
        } = await AxiosFetch(opts);
        this.shareFilterUsersList = value;
      } catch (error) {
        console.error(error);
        console.error(error.response.data);
      }
    },
    resetRowSelection() {
      this.disputeSelectedRows = [];
      this.disputeSelectedRowsByPage = {};
    },
    selectedRowsInPage() {
      const rows =
        this.disputeSelectedRowsByPage[`page${this.pagination.activePage}`];
      if (rows) {
        this.selectedRowsPerPage = rows.map((item) => item.ohpDisputeId);
      } else {
        this.selectedRowsPerPage = [];
      }
    },
    getSelectedRows() {
      if (isEmpty(this.disputeSelectedRowsByPage)) {
        return [];
      }
      const selectedDisputes = Object.keys(
        this.disputeSelectedRowsByPage
      ).reduce((acc, page) => {
        const items = this.disputeSelectedRowsByPage[page];
        return [...acc, ...items];
      }, []);
      return selectedDisputes;
    },
    selectAllEvent(records) {
      this.disputeSelectedRowsByPage[`page${this.pagination.activePage}`] = [
        ...records,
      ];
      this.disputeSelectedRows = this.getSelectedRows();
      this.selectedRowsInPage();
    },
    selectChangeEvent(records) {
      this.disputeSelectedRowsByPage[`page${this.pagination.activePage}`] = [
        ...records,
      ];
      this.disputeSelectedRows = this.getSelectedRows();
      this.selectedRowsInPage();
    },
    onExportExcelModalOpen() {
      this.isExportExcelModalVisible = true;
    },
    onExportModalClose() {
      this.isExportExcelModalVisible = false;
    },
    handleMultiActionSelect({ value }) {
      if (value === "Update_casedetails") {
        if (this.disputeSelectedRows.length) {
          const differentCaseDetails = this.disputeSelectedRows.filter(
            (item) =>
              item.disputeStage !== this.disputeSelectedRows[0].disputeStage ||
              item.statusCode !== this.disputeSelectedRows[0].statusCode ||
              item.isRedisputed !== this.disputeSelectedRows[0].isRedisputed ||
              item?.disputeStage?.toLowerCase() === "redispute"
          );
          if (!differentCaseDetails.length) {
            this.updateStatusFromListView = this.disputeSelectedRows[0];
            this.getCaseDetailsInfo(this.disputeSelectedRows[0]);
          } else {
            this.showUpdateAlertModal = true;
          }
        }
      } else if (value === "Update_voice_dispute_bulk") {
        if (this.disputeSelectedRows.length) {
          const differentDisputeContact = this.disputeSelectedRows.filter(
            (item) =>
              item.contactPerson !==
                this.disputeSelectedRows[0].contactPerson ||
              item.contactEmail !== this.disputeSelectedRows[0].contactEmail
          );
          const disputesNotForDwV = this.disputeSelectedRows.filter((item) => {
            if (
              !(
                statusCodesToEnableDwV.includes(item.statusCode) &&
                disputeStatusToEnableDwV.includes(item.disputeStage)
              )
            ) {
              return item;
            }
          });
          if (differentDisputeContact.length || disputesNotForDwV.length) {
            this.showUpdateAlertModal = true;
          }
        }
      }
      this.disputeModalType = value;
    },
    async createBulkVoiceDisputes(bulkVoiceDisputedata, successCallback) {
      try {
        this.showLoader();
        const { data } = await AxiosFetchForMsal(
          disputeActions.createBulkVoiceDisputes(
            bulkVoiceDisputedata,
            await getMsalIdToken(this)
          )
        );
        this.hideLoader();
        if (typeof successCallback === "function") {
          successCallback(data);
        }
        showToast("success", "Voice disputes created successfully!");
      } catch (err) {
        this.hideLoader();
        showToast(
          "error",
          err?.response?.data?.message ||
            "Unable to create voice dispute, please try again!"
        );
        console.error(err);
      }
    },
    updateDisputeRecords() {
      this.disputeRecordsLoading = true;
      setTimeout(() => {
        this.resetRowSelection();
        this.selectedRowsInPage();
        this.fetchAllDisputes();
        this.getAssignedDisputeList();
      }, 2000);
      this.disputeRecordsLoading = false;
    },
    showErrorToast(err) {
      showToast(
        "error",
        err?.response?.data?.message ||
          "Unable to update Dispute, please try again!"
      );
    },
    async updateBulkAssigneeForm(payload, successCallback) {
      try {
        this.showLoader();
        const { data } = await AxiosFetch(
          disputeActions.updateAssigneeDisputeDetails(
            payload,
            await getMsalIdToken(this)
          )
        );
        if (data.length) {
          let successIds = [];
          let failedIds = [];
          data.forEach((item) => {
            if (item.claimStatus === "OK") {
              successIds.push(item.ohpDisputeId);
            } else {
              failedIds.push(item.ohpDisputeId);
            }
          });
          if (successIds.length) {
            if (typeof successCallback === "function") {
              successCallback(successIds);
            }
            showToast(
              "success",
              `Disputes: ${successIds
                .map((item) => item)
                .join(", ")} were updated successfully!`,
              10000
            );
          }
          if (failedIds.length) {
            showToast(
              "error",
              `Failed to update the disputes: ${failedIds
                .map((item) => item)
                .join(", ")}, please try again!`,
              10000
            );
          }
        }
        this.hideLoader();
        this.onModalClose();
        await this.updateDisputeRecords();
      } catch (err) {
        this.hideLoader();
        this.showErrorToast(err);
        console.error(err);
      }
    },
    async updateBulkTenderForm(payload, successCallback) {
      try {
        this.showLoader();
        const { data } = await AxiosFetch(
          disputeActions.updateBulkTender(payload, await getMsalIdToken(this))
        );
        const successResponse = (data.response || [])
          .filter((item) => item.status === "SUCCESS")
          .map((item) => item.ohpDisputeId);
        const failureResponse = (data.response || [])
          .filter((item) => item.status === "FAILED")
          .map((item) => item.ohpDisputeId);
        if (successResponse.length) {
          if (typeof successCallback === "function") {
            successCallback(successResponse);
          }
          showToast(
            "success",
            `Disputes: ${successResponse
              .map((item) => item)
              .join(", ")} were updated successfully!`,
            10000
          );
        }
        if (Object.keys(failureResponse).length) {
          showToast(
            "error",
            "Failed to update the remaining disputes, please try again"
          );
        }
        this.hideLoader();
        this.onModalClose();
        await this.updateDisputeRecords();
      } catch (err) {
        this.hideLoader();
        showToast("error", "Failed to update the disputes, please try again");
        console.error(err);
      }
    },
    onModalClose() {
      this.disputeModalType = "";
      this.showUpdateAlertModal = false;
      this.showBulkUpdateError = false;
      if (
        this.updateStatusFromListView?.disputeStage?.toLowerCase() ===
        "redispute"
      ) {
        this.fetchDisputeRecords();
      }
      if (this.bulkUpdateTimeout) {
        window.location.reload();
      }
    },
    onSearchUpdateFacetIfNotFound({ query, facet }) {
      this.facetSearchTerm = query;
      this.selectedFacetFieldName = facet;
      this.facetToSkip = "";
    },
    onClearFacet({ query, facet }) {
      this.facetSearchTerm = query;
      this.selectedFacetFieldName = facet;
      this.debounceTriggerFetchFacet("facet_search");
    },
    async updateBulkContactDetails(payload) {
      try {
        this.showLoader();
        const data = await AxiosFetch(
          disputeActions.updateBulkDisputes(
            {
              data: payload,
            },
            await getMsalIdToken(this)
          )
        );
        if (data?.status === 200 && data?.data?.length) {
          showToast("success", `Success`);
          localStorage.setItem("bulk_create_id", data?.data);
          this.bulkCreatedId = data?.data;
        } else {
          showToast("error", "Failed to update the disputes, please try again");
        }
        this.hideLoader();
        this.onModalClose();
      } catch (err) {
        this.hideLoader();
        showToast("error", "Failed to update the disputes, please try again");
        console.error(err);
      }
    },
    addCaseAging(items) {
      this.disputeRecords = items.map((item) => ({
        ...item,
        ...getCaseAging(item),
      }));
    },
    async onSavedFilterDelete(filter_title) {
      console.log(filter_title);
      this.isSavedFiltersLoading = true;
      if (this.currentFilter.name === filter_title) {
        this.onFilterClear();
      }
      try {
        const payload = await userActions.deleteFilterPreference(
          `Bearer ${await getMsalIdToken(this)}`,
          `Bearer ${await getMsalAccessToken(this)}`,
          filter_title
        );
        await AxiosFetch(payload);
        await this.fetchFilterPreference();
        this.isSavedFiltersLoading = false;
      } catch (err) {
        console.log(err);
        showToast(
          "error",
          "Unable to delete the saved filter, please try again later"
        );
        this.isSavedFiltersLoading = false;
      }
    },
    onClear() {
      if (this.searchTerm) {
        this.searchTerm = "";
        this.appliedSearchTerm = "";
        this.fetchAllDisputes();
      }
    },
    onSortChange({ value }) {
      if (value === "Default") {
        this.sortOrderConfiguration = {};
        localStorage.removeItem("custom_sort_name");
        localStorage.removeItem(`${cacheNames.filters}_for_sort_order`);
      }
    },
    onChangeItemsPerPage({ value }) {
      this.setActivePage(1);
      this.pagination.itemsPerPage = value;
      this.resetRowSelection();
      this.selectedRowsInPage();
    },
    async fetchVoiceDisputes(ohpDisputeId, successCallback) {
      try {
        const { data } = await AxiosFetchForMsal(
          disputeActions.getVoiceDisputes(
            ohpDisputeId,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (typeof successCallback === "function") {
          successCallback(data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveBulkComments(payload, additionalData) {
      try {
        await AxiosFetchForMsal(
          disputeActions.saveBulkComments(
            payload,
            additionalData?.isExternal,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
      } catch (err) {
        console.error(err);
      }
    },
    async saveComments(payload, additionalData) {
      const { ohpDisputeId, hideLoader, isExternal } = additionalData;
      try {
        await AxiosFetchForMsal(
          disputeActions.saveComments(
            ohpDisputeId,
            isExternal,
            payload,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        if (hideLoader) {
          this.disputeModalLoading = false;
          this.onModalClose();
        }
      } catch (err) {
        console.error(err);
      }
    },
    selectChangeHandler({ value }) {
      this.selectedCasesCount = { value: value, label: `${value}` };
    },
    async assignCases() {
      try {
        const {
          idTokenClaims: { EmployeeID: employeeId },
        } = this.$store.getters.getTokenData;

        const { data } = await AxiosFetchForMsal(
          disputeActions.assignAutoAllocateCases(
            employeeId,
            this.selectedCasesCount?.value,
            await getMsalIdToken(this)
          )
        );
        showToast("success", `${data}`);
        this.isAutoAllocationModalVisible = true;
        this.selectedCasesCount = {
          value: "",
          label: "Select Number of cases",
        };
      } catch (error) {
        this.selectedCasesCount = {
          value: "",
          label: "Select Number of cases",
        };
        showToast("error", "Unable to allocate dispute. please try again");
      }
    },
    async getAssignedDisputeList() {
      let promiseArray = [];
      const msalToken = await getMsalIdToken(this);

      const {
        idTokenClaims: { EmployeeID: employeeId, name: userName },
      } = this.$store.getters.getTokenData;

      promiseArray.push(
        disputeActions.getDisputeList(
          {
            params: {
              page_no: this.pagination.activePage - 1,
              page_size: this.pagination.itemsPerPage,
            },
            data: {
              object_id: "disputes-view",
              filters: [
                {
                  property_id: "disputeStage",
                  values: ["<BLANK>", "New"],
                  filterName: "Dispute stage",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "reasonCode",
                  values: [
                    "0001",
                    "0002",
                    "0004",
                    "0003",
                    "0009",
                    "0007",
                    "0010",
                    "0008",
                    "0011",
                    "0012",
                    "0014",
                  ],
                  filterName: "Reason code",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "processorName",
                  values: ["<BLANK>"],
                  filterName: "Processor name",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "disputeAgentName",
                  values: [`${userName}`],
                  filterName: "Assignee",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "referenceKey",
                  values: [
                    "EXPORT",
                    "DET-INV",
                    "IMPORT",
                    "DEM-INV",
                    "MANUAL",
                    "SI_EXPORT",
                    "SI_IMPORT",
                    "INVOICE",
                    "S_EXP–CREDIT",
                    "EXP–CREDIT",
                    "S_EXP�CREDIT",
                    "S_IMP–CREDIT",
                    "<BLANK>",
                    "IMP–CREDIT",
                    "S_IMP�CREDIT",
                    "EXP�CREDIT",
                    "DET–CREDIT",
                    "DET�CREDIT",
                    "DEM–CREDIT",
                    "IMP�CREDIT",
                    "DEM�CREDIT",
                    "EXPORT - DET",
                    "OF",
                    "CREDIT",
                    "OTHER",
                    "DET",
                    "SI_INVOICE",
                    "ONA-IMP",
                    "DEM",
                    "DET INV",
                    "ONA_DND",
                    "DD",
                    "ONA",
                    "DETENTION",
                    "BANK",
                    "ONA-EXP",
                    "VALID CREDIT",
                    "DEM/DET",
                    "FRT",
                    "PB-INV",
                    "EXPORT-DET",
                    "DET_INV",
                    "OA-EXPORT",
                    "ONA-DET",
                    "ONA_DEM",
                    "*OVERPAYMENT",
                    "D&D",
                    "DEPOSIT",
                    "DET - INV",
                    "DET-CREDIT",
                    "EXP-CREDIT",
                    "GUARANTEE",
                    "IMP DEM",
                    "IMP DET",
                    "ONA DET",
                    "ONA_DET",
                    "ONA_EXP",
                    "SEC-DEPOSIT",
                    "*1052ACC",
                    "3400428351",
                    "3401270654",
                    "3401573936",
                    "AMD FEE",
                    "CAIU6011452/",
                    "DEM - INV",
                    "DEM / DET",
                    "DEMURRAGE",
                    "DET EXCESS",
                    "DET MSKU5933",
                    "DET–INV",
                    "FREIGHT",
                    "GARANTIA",
                    "IMPORT CREDI",
                    "OA-CREDIT",
                    "ONA EXP",
                    "ONA_IMP",
                    "RATE CORRECT",
                    "SECURITY",
                    "SECURITY DEP",
                    "SI_CREDIT",
                    "SUDU1995850/",
                    "X-TRADE",
                    "ZQ",
                  ],
                  filterName: "Reference key",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
              ],
              search: null,
            },
          },
          msalToken
        )
      );

      promiseArray.push(
        disputeActions.getDisputeList(
          {
            params: {
              page_no: this.pagination.activePage - 1,
              page_size: this.pagination.itemsPerPage,
            },
            data: {
              object_id: "disputes-view",
              filters: [
                {
                  property_id: "disputeStage",
                  values: ["<BLANK>", "New"],
                  filterName: "Dispute stage",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "reasonCode",
                  values: [
                    "0001",
                    "0002",
                    "0004",
                    "0003",
                    "0009",
                    "0007",
                    "0010",
                    "0008",
                    "0011",
                    "0012",
                    "0014",
                  ],
                  filterName: "Reason code",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "processorName",
                  values: [`${employeeId}`],
                  filterName: "Processor name",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "disputeAgentName",
                  values: [`${userName}`],
                  filterName: "Assignee",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "referenceKey",
                  values: [
                    "EXPORT",
                    "DET-INV",
                    "IMPORT",
                    "DEM-INV",
                    "MANUAL",
                    "SI_EXPORT",
                    "SI_IMPORT",
                    "INVOICE",
                    "S_EXP–CREDIT",
                    "EXP–CREDIT",
                    "S_EXP�CREDIT",
                    "S_IMP–CREDIT",
                    "<BLANK>",
                    "IMP–CREDIT",
                    "S_IMP�CREDIT",
                    "EXP�CREDIT",
                    "DET–CREDIT",
                    "DET�CREDIT",
                    "DEM–CREDIT",
                    "IMP�CREDIT",
                    "DEM�CREDIT",
                    "EXPORT - DET",
                    "OF",
                    "CREDIT",
                    "OTHER",
                    "DET",
                    "SI_INVOICE",
                    "ONA-IMP",
                    "DEM",
                    "DET INV",
                    "ONA_DND",
                    "DD",
                    "ONA",
                    "DETENTION",
                    "BANK",
                    "ONA-EXP",
                    "VALID CREDIT",
                    "DEM/DET",
                    "FRT",
                    "PB-INV",
                    "EXPORT-DET",
                    "DET_INV",
                    "OA-EXPORT",
                    "ONA-DET",
                    "ONA_DEM",
                    "*OVERPAYMENT",
                    "D&D",
                    "DEPOSIT",
                    "DET - INV",
                    "DET-CREDIT",
                    "EXP-CREDIT",
                    "GUARANTEE",
                    "IMP DEM",
                    "IMP DET",
                    "ONA DET",
                    "ONA_DET",
                    "ONA_EXP",
                    "SEC-DEPOSIT",
                    "*1052ACC",
                    "3400428351",
                    "3401270654",
                    "3401573936",
                    "AMD FEE",
                    "CAIU6011452/",
                    "DEM - INV",
                    "DEM / DET",
                    "DEMURRAGE",
                    "DET EXCESS",
                    "DET MSKU5933",
                    "DET–INV",
                    "FREIGHT",
                    "GARANTIA",
                    "IMPORT CREDI",
                    "OA-CREDIT",
                    "ONA EXP",
                    "ONA_IMP",
                    "RATE CORRECT",
                    "SECURITY",
                    "SECURITY DEP",
                    "SI_CREDIT",
                    "SUDU1995850/",
                    "X-TRADE",
                    "ZQ",
                  ],
                  filterName: "Reference key",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
              ],
              search: null,
            },
          },
          msalToken
        )
      );

      promiseArray.push(
        disputeActions.getDisputeList(
          {
            params: {
              page_no: this.pagination.activePage - 1,
              page_size: this.pagination.itemsPerPage,
            },
            data: {
              object_id: "disputes-view",
              filters: [
                {
                  property_id: "disputeAgentName",
                  values: ["Unassigned", "<BLANK>"],
                  filterName: "Assignee",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "disputeStage",
                  values: ["<BLANK>", "New"],
                  filterName: "Dispute stage",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "reasonCode",
                  values: [
                    "0001",
                    "0002",
                    "0004",
                    "0003",
                    "0009",
                    "0007",
                    "0010",
                    "0008",
                    "0011",
                    "0012",
                    "0014",
                  ],
                  filterName: "Reason code",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "processorName",
                  values: [`${employeeId}`],
                  filterName: "Processor name",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
                {
                  property_id: "referenceKey",
                  values: [
                    "EXPORT",
                    "DET-INV",
                    "IMPORT",
                    "DEM-INV",
                    "MANUAL",
                    "SI_EXPORT",
                    "SI_IMPORT",
                    "INVOICE",
                    "S_EXP–CREDIT",
                    "EXP–CREDIT",
                    "S_EXP�CREDIT",
                    "S_IMP–CREDIT",
                    "<BLANK>",
                    "IMP–CREDIT",
                    "S_IMP�CREDIT",
                    "EXP�CREDIT",
                    "DET–CREDIT",
                    "DET�CREDIT",
                    "DEM–CREDIT",
                    "IMP�CREDIT",
                    "DEM�CREDIT",
                    "EXPORT - DET",
                    "OF",
                    "CREDIT",
                    "OTHER",
                    "DET",
                    "SI_INVOICE",
                    "ONA-IMP",
                    "DEM",
                    "DET INV",
                    "ONA_DND",
                    "DD",
                    "ONA",
                    "DETENTION",
                    "BANK",
                    "ONA-EXP",
                    "VALID CREDIT",
                    "DEM/DET",
                    "FRT",
                    "PB-INV",
                    "EXPORT-DET",
                    "DET_INV",
                    "OA-EXPORT",
                    "ONA-DET",
                    "ONA_DEM",
                    "*OVERPAYMENT",
                    "D&D",
                    "DEPOSIT",
                    "DET - INV",
                    "DET-CREDIT",
                    "EXP-CREDIT",
                    "GUARANTEE",
                    "IMP DEM",
                    "IMP DET",
                    "ONA DET",
                    "ONA_DET",
                    "ONA_EXP",
                    "SEC-DEPOSIT",
                    "*1052ACC",
                    "3400428351",
                    "3401270654",
                    "3401573936",
                    "AMD FEE",
                    "CAIU6011452/",
                    "DEM - INV",
                    "DEM / DET",
                    "DEMURRAGE",
                    "DET EXCESS",
                    "DET MSKU5933",
                    "DET–INV",
                    "FREIGHT",
                    "GARANTIA",
                    "IMPORT CREDI",
                    "OA-CREDIT",
                    "ONA EXP",
                    "ONA_IMP",
                    "RATE CORRECT",
                    "SECURITY",
                    "SECURITY DEP",
                    "SI_CREDIT",
                    "SUDU1995850/",
                    "X-TRADE",
                    "ZQ",
                  ],
                  filterName: "Reference key",
                  type: "EXACT_MATCH",
                  exclude: false,
                  updatable: true,
                },
              ],
              search: null,
            },
          },
          msalToken
        )
      );

      const searchRequestPayload = disputeActions.getDisputeList(
        {
          params: {
            page_no: this.pagination.activePage - 1,
            page_size: this.pagination.itemsPerPage,
          },
          data: {
            object_id: "disputes-view",
            filters: [
              {
                property_id: "disputeStage",
                values: ["<BLANK>", "New"],
                filterName: "Dispute stage",
                type: "EXACT_MATCH",
                exclude: false,
                updatable: true,
              },
              {
                property_id: "reasonCode",
                values: [
                  "0001",
                  "0002",
                  "0004",
                  "0003",
                  "0009",
                  "0007",
                  "0010",
                  "0008",
                  "0011",
                  "0012",
                  "0014",
                ],
                filterName: "Reason code",
                type: "EXACT_MATCH",
                exclude: false,
                updatable: true,
              },
              {
                property_id: "processorName",
                values: [`${employeeId}`],
                filterName: "Processor name",
                type: "EXACT_MATCH",
                exclude: false,
                updatable: true,
              },
              {
                property_id: "referenceKey",
                values: [
                  "EXPORT",
                  "DET-INV",
                  "IMPORT",
                  "DEM-INV",
                  "MANUAL",
                  "SI_EXPORT",
                  "SI_IMPORT",
                  "INVOICE",
                  "S_EXP–CREDIT",
                  "EXP–CREDIT",
                  "S_EXP�CREDIT",
                  "S_IMP–CREDIT",
                  "<BLANK>",
                  "IMP–CREDIT",
                  "S_IMP�CREDIT",
                  "EXP�CREDIT",
                  "DET–CREDIT",
                  "DET�CREDIT",
                  "DEM–CREDIT",
                  "IMP�CREDIT",
                  "DEM�CREDIT",
                  "EXPORT - DET",
                  "OF",
                  "CREDIT",
                  "OTHER",
                  "DET",
                  "SI_INVOICE",
                  "ONA-IMP",
                  "DEM",
                  "DET INV",
                  "ONA_DND",
                  "DD",
                  "ONA",
                  "DETENTION",
                  "BANK",
                  "ONA-EXP",
                  "VALID CREDIT",
                  "DEM/DET",
                  "FRT",
                  "PB-INV",
                  "EXPORT-DET",
                  "DET_INV",
                  "OA-EXPORT",
                  "ONA-DET",
                  "ONA_DEM",
                  "*OVERPAYMENT",
                  "D&D",
                  "DEPOSIT",
                  "DET - INV",
                  "DET-CREDIT",
                  "EXP-CREDIT",
                  "GUARANTEE",
                  "IMP DEM",
                  "IMP DET",
                  "ONA DET",
                  "ONA_DET",
                  "ONA_EXP",
                  "SEC-DEPOSIT",
                  "*1052ACC",
                  "3400428351",
                  "3401270654",
                  "3401573936",
                  "AMD FEE",
                  "CAIU6011452/",
                  "DEM - INV",
                  "DEM / DET",
                  "DEMURRAGE",
                  "DET EXCESS",
                  "DET MSKU5933",
                  "DET–INV",
                  "FREIGHT",
                  "GARANTIA",
                  "IMPORT CREDI",
                  "OA-CREDIT",
                  "ONA EXP",
                  "ONA_IMP",
                  "RATE CORRECT",
                  "SECURITY",
                  "SECURITY DEP",
                  "SI_CREDIT",
                  "SUDU1995850/",
                  "X-TRADE",
                  "ZQ",
                ],
                filterName: "Reference key",
                type: "EXACT_MATCH",
                exclude: false,
                updatable: true,
              },
            ],
            search: null,
          },
        },
        msalToken
      );
      // Parallel API call's
      await Promise.allSettled(
        promiseArray?.map((endpoint) => AxiosFetchForMsal(endpoint))
      )
        .then((res) => {
          let search_records = [];
          res.forEach((item) => {
            if (item.status === "rejected") {
              return false;
            }
            search_records = [
              ...search_records,
              ...item?.value?.data?.search_records,
            ];
          });
          this.assignedDisputeList = search_records;
        })
        .catch((e) => {
          this.isAutoAllocationModalVisible = false;
          this.getAssignedDisputeList();
        });
    },
    onAutoAllocationModalClose() {
      this.isAutoAllocationModalVisible = false;
      this.getAssignedDisputeList();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.sign-out-button {
  margin-top: 80px;
}

.filter-area {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  width: inherit;
  &-title {
    color: var(--primary-text);
    font-size: 18px;
    font-family: "Maersk Headline";
    margin: 0 0 24px;
  }
}

.filter-visible {
  & .main-content {
    margin-left: 494px;
    max-width: 950px;

    @media (min-width: 1600px) {
      max-width: 1150px;
    }
  }
  & .dashboard {
    max-width: 950px;
    padding: 24px;
    padding-left: 0;

    @media (min-width: 1600px) {
      max-width: 1150px;
      padding: 24px 0;
    }
  }
  & .table-style {
    padding-left: 0;
  }
  & .grid-cards-item-content {
    @media (max-width: 1600px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
  & .grid-cards-item-header-left-contents-dates {
    @media (max-width: 1600px) {
      display: flex;
      flex-direction: column;
    }
  }
  & header.ign-header {
    margin-left: 468px;
    max-width: 1228px;
  }
  & #app-footer {
    margin-left: 494px;
    max-width: 1220px;
  }
}

.dashboard {
  padding: 24px;
  display: flex;
  width: 1280px;
  margin: 0 auto;
  flex-direction: column;
  @media (min-width: 1400px) {
    padding: 24px 0;
  }
  &__warning {
    margin-bottom: 20px;
  }

  & .content-area {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    & .case-assign-area {
      justify-content: flex-end;
      display: flex;
      @include media("<=desktop") {
        justify-content: normal;
        margin-top: 12px;
      }
      &__label {
        margin-right: 8px;
        margin-top: 10px;
      }
      &__cases {
        width: 211px;
        margin-right: 14px;
        .vs__dropdown-toggle {
          height: 41.6px;
        }
      }
      &.button-pull-cases {
        .button__icon {
          color: #fff;
        }
      }
    }
    & .configure-area {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1rem;
      width: calc(100vw - 2rem);

      @media (min-width: 1200px) {
        width: 100%;
      }

      & .button-group__button {
        margin-top: 0;
      }
    }

    & .tab-area {
      & .form-input {
        max-width: 20rem;
      }
      &__bulk-menu {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        @include media("<355px") {
          flex-direction: column;
          align-items: flex-start;
        }
        &__label {
          font-size: 14px;
          color: var(--secondary-text);
          margin-right: 1rem;
          @include media("<355px") {
            margin-bottom: 8px;
          }
        }
      }
    }

    & .search-area {
      margin: 2rem 0;
      display: flex;
      justify-content: space-between;
      & .left-content {
        display: flex;
        flex: 1;
      }

      & .right-content {
        display: flex;
        justify-content: flex-end;
        @include media("<=desktop") {
          justify-content: normal;
          margin-top: 12px;
        }
      }

      & .search-box {
        display: flex;
        flex: 1;
        flex-direction: column;
        margin: 0 12px;
        max-width: 412px;

        & .search-cancel-button {
          display: none;
        }

        @include media("<=tablet") {
          display: none;
        }
      }

      & .search-button {
        display: none;
        @include media("<=tablet") {
          display: inline-block;
        }
      }
      & .download-button {
        margin: 0;
        margin-right: 0;
      }

      & .sort-area {
        margin-right: 12px;
        & .form-group {
          display: flex;
          align-items: center;
          & .form-label {
            margin-bottom: 0;
            margin-right: 8px;
          }
        }
      }

      @include media("<=desktop") {
        display: block;
        margin-top: 12px;
      }

      @include media("<=tablet") {
        flex-direction: column;
        margin-top: 12px;
        &.search-active {
          & .left-content {
            & .button-group {
              display: none;
            }
            & .search-box {
              display: flex;
              flex: 1;
              margin-left: 0;
              width: 100%;
              flex-direction: row;
              & .form-group {
                width: 100%;
              }
              & .search-cancel-button {
                display: inline-block;
                margin-left: 12px;
                cursor: pointer;
                align-self: center;
              }
            }
          }
        }
      }
    }

    & .tabbar {
      flex-direction: row;
      justify-content: space-between;
      display: flex;
      align-items: center;
    }
    @include media("<=tablet") {
      margin-left: 0;

      & .tabbar {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 24px;
      }
    }

    & > h4 {
      color: var(--primary-text);
    }

    & .error-message {
      & ul {
        padding-left: 40px;
        & li {
          font-family: "Maersk Text";
          list-style: disc;
        }
      }
    }

    & .title-area {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @include media("<=desktop") {
        display: inline;
      }
      & .filter-container {
        display: flex;
      }

      & .title {
        color: var(--primary-title-text);
        margin-bottom: 8px;
        margin-top: 0;

        &--color {
          color: var(--Blue-300-Maersk);
        }
      }

      & .filter-button {
        display: none;

        @include media("<=desktop") {
          font-family: "Maersk Headline";
          align-items: center;
          display: flex;
          background-color: var(--card-bg);
          box-shadow: 0px 1px 2px var(--shadow-color);
          padding: 4px 8px;
          cursor: pointer;
          border-radius: 2px;

          & > span {
            font-size: 16px;
            color: var(--primary-text);
            margin-right: 8px;
          }
          & > div {
            display: flex;
            & > svg {
              fill: var(--icon-bg);
            }
          }
        }
      }
    }
  }
}

.grid-cards {
  display: flex;
  flex-wrap: wrap;

  & .hidden {
    display: none;
  }

  h4 {
    font-size: 18px;
    font-family: "Maersk Headline Bold";
    color: var(--primary-text);
  }
}

.toggle-area {
  display: flex;
  align-items: center;
  & span {
    font-family: "Maersk Headline";
    font-size: 14px;
    margin-left: 12px;
    margin-right: 12px;
    color: var(--primary-text);
  }
}

.dashboard-empty-state {
  margin-top: 24px;
  & h4 {
    margin-top: 24px;
    font-size: 18px;
    color: var(--primary-text);
    font-family: "Maersk Headline";
  }
  & img {
    width: 350px;
  }
}

.menu_container {
  display: flex;
  justify-content: space-between;
  @include media("<720px") {
    flex-direction: column;
  }
}

.add-footer-margin {
  margin-bottom: 20vh;
}

.error {
  color: red;
  font-size: 12px;
  // margin-left: 1rem;
}

.filter-toggle-button-container {
  position: relative;
  padding-right: 24px;

  .button-group__button {
    margin-right: 0;
  }

  .filter-change-circle {
    position: absolute;
    top: 14px;
    left: 103px;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    display: inline-block;
    background: var(--Red-300-Accent-Red);
    z-index: 10;
  }
}
.table-style {
  overflow: auto;
  height: calc(100vh - 86px);

  @media (max-width: 1600px) {
    padding: 0 24px;
  }

  .dashboard {
    padding: 24px 0;
    display: unset;
    overflow: auto;
  }
  .content-area,
  .pagination {
    position: sticky;
    left: 0;
    padding: 0 20px 0 0;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>
